/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddPostDto } from '../models/AddPostDto';
import type { ApprovePostDto } from '../models/ApprovePostDto';
import type { RegenerateCreativeDto } from '../models/RegenerateCreativeDto';
import type { RescheduleDto } from '../models/RescheduleDto';
import type { WeeklyQueueItemDto } from '../models/WeeklyQueueItemDto';
import type { WeeklyQueueResponseDto } from '../models/WeeklyQueueResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class WeeklyQueueService {
    /**
     * Get the current week of autopilot posts to review
     * @param weekStart Anchor date for the 7-day horizon (ISO date). Defaults to today (UTC). Horizon is always `anchor → anchor+7`.
     * @returns WeeklyQueueResponseDto
     * @throws ApiError
     */
    public static weeklyQueueControllerGetWeeklyQueueV1(
        weekStart?: string,
    ): CancelablePromise<WeeklyQueueResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/weekly-queue',
            query: {
                'weekStart': weekStart,
            },
        });
    }
    /**
     * Move a creative to a new schedule slot.
     * @param id
     * @param requestBody
     * @returns WeeklyQueueItemDto
     * @throws ApiError
     */
    public static weeklyQueueControllerRescheduleV1(
        id: string,
        requestBody: RescheduleDto,
    ): CancelablePromise<WeeklyQueueItemDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/reschedule',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Approve a review-mode autopilot post for publishing. Stamps the whole post (primary + confirmed siblings) so it publishes at its scheduled time. With an optional `platforms` (+ `scheduledAt`) body the approval also carries the platform selection: selected previews become scheduled siblings and `confirmedPlatforms` is written, in the same transaction.
     * @param id
     * @param requestBody
     * @returns WeeklyQueueItemDto
     * @throws ApiError
     */
    public static weeklyQueueControllerApproveV1(
        id: string,
        requestBody?: ApprovePostDto,
    ): CancelablePromise<WeeklyQueueItemDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/approve',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Generate a one-off post for a specific day using the autopilot generator (same magic, manually triggered)
     * @param requestBody
     * @returns any Generation started
     * @throws ApiError
     */
    public static weeklyQueueControllerAddPostV1(
        requestBody: AddPostDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/weekly-queue/add-post',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Throw away the current draft and ask the autopilot for a fresh one in the same slot. Optional body field overrides the content direction for this single regeneration only — the global plan is untouched.
     * @param id
     * @param requestBody
     * @returns any Regeneration started
     * @throws ApiError
     */
    public static weeklyQueueControllerRegenerateV1(
        id: string,
        requestBody: RegenerateCreativeDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/creatives/{id}/regenerate',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
